{
  "chapel": {
    "u": 10,
    "v": 13.4,
    "angleDeg": -8,
    "u0": -16,
    "chordU": 11.5,
    "vc": 0,
    "half": 4.3,
    "eaveY": 10.8,
    "ridgeY": 16.8
  },
  "belfry": {
    "u": 5,
    "v": 0,
    "radius": 0.48,
    "foot": 15.2,
    "eaves": 17.2,
    "tip": 22.3
  },
  "ranges": [
    {
      "id": "southern-gabled-range",
      "u": -13,
      "v": -14.6,
      "angleDeg": 0,
      "length": 57,
      "width": 6.8,
      "eaves": 9.4,
      "ridge": 14.1,
      "floors": 3,
      "bays": 12,
      "roof": "slate",
      "passage": 0,
      "roofGables": {
        "centres": [-24, -18, -12, -6, 0, 6, 12, 18, 24],
        "halfWidth": 0.8,
        "v0": 0.8,
        "v1": 3.4,
        "eaves": 13.1,
        "ridge": 15.1,
        "sill": 11.45,
        "top": 12.45
      }
    },
    {
      "id": "quay-gate-range",
      "u": -21.3,
      "v": 6.3,
      "angleDeg": 216.8,
      "length": 48,
      "width": 6.4,
      "eaves": 9.0,
      "ridge": 13.7,
      "floors": 3,
      "bays": 9,
      "roof": "slate",
      "passage": 3.0,
      "roofGables": {
        "centres": [-20, -14, -8, -2, 4, 10, 16, 20],
        "halfWidth": 0.75,
        "v0": 0.8,
        "v1": 3.2,
        "eaves": 12.7,
        "ridge": 14.8,
        "sill": 11.049999999999999,
        "top": 12.049999999999999
      },
      "passageU": -6
    },
    {
      "id": "eastern-court-range",
      "u": 16.9,
      "v": -1.7,
      "angleDeg": -99,
      "length": 25,
      "width": 5.6,
      "eaves": 7.5,
      "ridge": 11.8,
      "floors": 2,
      "bays": 5,
      "roof": "slate",
      "passage": 0
    }
  ],
  "floors": [
    {
      "ring": [
        [-38, -11.3],
        [13, -10.8],
        [16, 8.4],
        [-1.8, 11.8],
        [-6, 17.2]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-30, -8],
        [10, -7.5],
        [12.5, 5.7],
        [-5, 8.9]
      ],
      "height": 0.04,
      "garden": true
    }
  ],
  "walls": [
    {
      "from": [-41.0, -12.0],
      "to": [-40.5, -7.8],
      "width": 0.4,
      "height": 1.8
    }
  ],
  "note": "Sint Geertruid is read from the 1538 painting and labelled 1544 woodcut as a narrow chapel with polygonal eastern choir and small roof belfry, long southern and quay ranges, shorter eastern range and tapered open court. The Rijksmuseum 1760 view RP-P-2019-412 derives from the 1544 map; its windows, roof gables and courtyard perspective are interpretive, not an independent medieval survey. The 1984 excavation confirms chapel and cemetery remains but the consulted museum record supplies no dimensioned plan. All component dimensions, angles, heights, openings, roof gables, private quay passage, soil edges and precinct boundary are fitted estimates. The separate Onze Lieve Vrouwegasthuis and its cemetery are not absorbed into this convent; the hospital’s documented 1432 right of way stays outside. The precise burial-ground boundary and room functions remain unresolved. Later sugar refining, the Nieuwe Nieuwstraat and modern hotel buildings are not backdated."
}
